import React from 'react';
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import CusButton from '@/components/CusButton';

type CompareTableProps = {
  tableName?: string;
  header: React.ReactNode[];
  body: {
    title: string;
    city: string | number;
    comparedCity: string | number;
  }[];
  hideExpand?: boolean;
};

const CompareTable = ({
  tableName,
  header,
  body,
  hideExpand,
}: CompareTableProps) => {
  const [expand, setExpand] = React.useState(false);

  return (
    <div
      className={`px-6 tablet:px-12 ${expand && 'bg-gray-50'} hover:bg-gray-50`}
    >
      <div className="grid h-20 items-center border-b border-gray-300 grid-cols-[2fr_2fr_2fr_1fr]">
        <span className="justify-self-start">{tableName}</span>
        <div className="justify-self-center">{header[0]}</div>
        <div className="justify-self-center">{header[1]}</div>
        <div className="justify-self-end">
          {!hideExpand && (
            <CusButton onClick={() => setExpand((expand) => !expand)}>
              <div className="text-denim flex items-center whitespace-nowrap">
                <span className="hidden tablet:inline">查看更多</span>
                {expand ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
              </div>
            </CusButton>
          )}
        </div>
      </div>
      {body.map(
        (item, index) =>
          expand && (
            <p
              className="grid h-16 items-center grid-cols-[2fr_2fr_2fr_1fr] last:border-b last:border-gray-300"
              key={index}
            >
              <span className="justify-self-start">{item.title}</span>
              <span className="justify-self-center">{item.city}</span>
              <span className="justify-self-center">{item.comparedCity}</span>
              <span className="justify-self-end" />
            </p>
          ),
      )}
    </div>
  );
};

export default CompareTable;
